define('collections/ProductCollection',[
    'evertrue',
    'underscore',
    'backbone',
    'ET/ETCollection',
    'models/roles/RoleModel'
], function ProductCollectionFactory (EverTrue, _, Backbone, ETCollection, RoleModel) {

    // Helper Utils for Formatting DNA and keeping
    // Default labels in one location

    var ProductCollection = ETCollection.extend({
        dna_key: "ET.Org.Products",

        defaults: [
            {name: "community", label: "Community"},
            {name: "givingtree", label: "GivingTree"},
            {name: "volunteers", label: "Volunteers"}
        ],

        resetProducts: function(products) {
            this.reset(this.parseProducts(products));
        },

        // Takes products from a serializedNestedObject form and
        // parse them into an array to be stored in DNA
        // expects: {community: {name: "community", status: "BUILD"}}
        parseProducts: function(products) {
            var self = this,
                toSave = [],
                org_roles = EverTrue.Organization.get("roles");

            _.each(products, function(product) {
                var defaults = _.findWhere(self.defaults, {name: product.name}) || {},
                    data = {name: product.name, label: defaults.label, status: product.status};
                if (!product.name) return;
                if (product.premium && product.name == "community") {
                    data.premium = true;
                }
                if (product.key && (product.name == "community")) {
                    data.key = product.key;
                }
                toSave.push(data);

                // If adding GivingTree product, and GivingTree User role doesn't exists, add it
                if (product.name == "givingtree" && org_roles.length && !_.findWhere(org_roles, {name: "GivingTree User"})) {
                    self.addGTRole("GivingTree User", true);
                }

                // If adding GivingTree product, and GivingTree Owner role doesn't exists, add it
                if (product.name == "givingtree" && org_roles.length && !_.findWhere(org_roles, {name: "GivingTree Owner"})) {
                    self.addGTRole("GivingTree Owner", true);
                }

                // If adding Volunteer product, and Volunteer User role doesn't exists, add it
                if (product.name == "volunteers" && org_roles.length && !_.findWhere(org_roles, {name: "Volunteer"})) {
                    self.addGTRole("Volunteer", false);
                }

                // If adding Volunteer product, and Volunteer Owner role doesn't exists, add it
                if (product.name == "volunteers" && org_roles.length && !_.findWhere(org_roles, {name: "Volunteer Lead"})) {
                    self.addGTRole("Volunteer Lead", false);
                }
            });

            return toSave;
        },

        addGTRole: function(role_name, can_see_private_data) {
            var gt_role = new RoleModel({name: role_name, can_see_private_data: can_see_private_data, remote_id: role_name}),
                org_roles = EverTrue.Organization.get("roles");

            gt_role.setOrganization(EverTrue.Organization.get("id"));
            gt_role.save();

            // Add Role to Local Data
            org_roles.push(gt_role.toJSON());
            EverTrue.Organization.set({roles: org_roles});
            EverTrue.Organization.saveToStorage();
        }

    });

    return ProductCollection;
});

